module.exports = __webpack_public_path__ + "img/pic1.cb08f19e.jpg";